import { css } from '@emotion/react';

export const contentWrapper = () => css`
  display: flex;

  justify-content: space-between;
  align-items: center;

  width: 100%;

  padding-left: 15px;
`;
